<template>
  <header class="module-head">
    <h2>{{ title }}</h2>
    <button v-if="action" @click="$emit('more')">{{ action }} <i class="el-icon-arrow-right" /></button>
  </header>
</template>

<script>
export default {
  name: "ModuleHead",
  props: {
    title: { type: String, required: true },
    action: { type: String, default: "" }
  }
}
</script>

